// Major US cities for the jobs location filter.
//
// The filter matches by substring against job.jobLocation ("Dallas" matches
// "Dallas, TX" and "Dallas, Texas, United States"), so `value` is the bare city
// name. One entry per unique city name — for names shared across states
// (Portland, Springfield…) the most populous city provides the label, and the
// substring match naturally covers the others.
export const US_CITY_OPTIONS = [
    { value: "Akron", label: "Akron, OH" },
    { value: "Albany", label: "Albany, NY" },
    { value: "Albuquerque", label: "Albuquerque, NM" },
    { value: "Alexandria", label: "Alexandria, VA" },
    { value: "Allentown", label: "Allentown, PA" },
    { value: "Alpharetta", label: "Alpharetta, GA" },
    { value: "Amarillo", label: "Amarillo, TX" },
    { value: "Anaheim", label: "Anaheim, CA" },
    { value: "Anchorage", label: "Anchorage, AK" },
    { value: "Ann Arbor", label: "Ann Arbor, MI" },
    { value: "Annapolis", label: "Annapolis, MD" },
    { value: "Arlington", label: "Arlington, TX" },
    { value: "Asheville", label: "Asheville, NC" },
    { value: "Athens", label: "Athens, GA" },
    { value: "Atlanta", label: "Atlanta, GA" },
    { value: "Augusta", label: "Augusta, GA" },
    { value: "Aurora", label: "Aurora, CO" },
    { value: "Austin", label: "Austin, TX" },
    { value: "Bakersfield", label: "Bakersfield, CA" },
    { value: "Baltimore", label: "Baltimore, MD" },
    { value: "Baton Rouge", label: "Baton Rouge, LA" },
    { value: "Beaverton", label: "Beaverton, OR" },
    { value: "Bellevue", label: "Bellevue, WA" },
    { value: "Bend", label: "Bend, OR" },
    { value: "Berkeley", label: "Berkeley, CA" },
    { value: "Bethesda", label: "Bethesda, MD" },
    { value: "Billings", label: "Billings, MT" },
    { value: "Birmingham", label: "Birmingham, AL" },
    { value: "Bismarck", label: "Bismarck, ND" },
    { value: "Bloomington", label: "Bloomington, MN" },
    { value: "Boca Raton", label: "Boca Raton, FL" },
    { value: "Boise", label: "Boise, ID" },
    { value: "Boston", label: "Boston, MA" },
    { value: "Boulder", label: "Boulder, CO" },
    { value: "Bozeman", label: "Bozeman, MT" },
    { value: "Bridgeport", label: "Bridgeport, CT" },
    { value: "Brooklyn", label: "Brooklyn, NY" },
    { value: "Buffalo", label: "Buffalo, NY" },
    { value: "Burbank", label: "Burbank, CA" },
    { value: "Burlington", label: "Burlington, VT" },
    { value: "Cambridge", label: "Cambridge, MA" },
    { value: "Cape Coral", label: "Cape Coral, FL" },
    { value: "Carlsbad", label: "Carlsbad, CA" },
    { value: "Carmel", label: "Carmel, IN" },
    { value: "Cary", label: "Cary, NC" },
    { value: "Casper", label: "Casper, WY" },
    { value: "Cedar Rapids", label: "Cedar Rapids, IA" },
    { value: "Centennial", label: "Centennial, CO" },
    { value: "Chandler", label: "Chandler, AZ" },
    { value: "Charleston", label: "Charleston, SC" },
    { value: "Charlotte", label: "Charlotte, NC" },
    { value: "Chattanooga", label: "Chattanooga, TN" },
    { value: "Chesapeake", label: "Chesapeake, VA" },
    { value: "Cheyenne", label: "Cheyenne, WY" },
    { value: "Chicago", label: "Chicago, IL" },
    { value: "Chula Vista", label: "Chula Vista, CA" },
    { value: "Cincinnati", label: "Cincinnati, OH" },
    { value: "Clarksville", label: "Clarksville, TN" },
    { value: "Clearwater", label: "Clearwater, FL" },
    { value: "Cleveland", label: "Cleveland, OH" },
    { value: "College Station", label: "College Station, TX" },
    { value: "Colorado Springs", label: "Colorado Springs, CO" },
    { value: "Columbia", label: "Columbia, SC" },
    { value: "Columbus", label: "Columbus, OH" },
    { value: "Concord", label: "Concord, CA" },
    { value: "Coral Springs", label: "Coral Springs, FL" },
    { value: "Corona", label: "Corona, CA" },
    { value: "Corpus Christi", label: "Corpus Christi, TX" },
    { value: "Cupertino", label: "Cupertino, CA" },
    { value: "Dallas", label: "Dallas, TX" },
    { value: "Danbury", label: "Danbury, CT" },
    { value: "Davenport", label: "Davenport, IA" },
    { value: "Dayton", label: "Dayton, OH" },
    { value: "Denton", label: "Denton, TX" },
    { value: "Denver", label: "Denver, CO" },
    { value: "Des Moines", label: "Des Moines, IA" },
    { value: "Detroit", label: "Detroit, MI" },
    { value: "Duluth", label: "Duluth, MN" },
    { value: "Durham", label: "Durham, NC" },
    { value: "El Paso", label: "El Paso, TX" },
    { value: "Elgin", label: "Elgin, IL" },
    { value: "Elizabeth", label: "Elizabeth, NJ" },
    { value: "Elk Grove", label: "Elk Grove, CA" },
    { value: "Erie", label: "Erie, PA" },
    { value: "Escondido", label: "Escondido, CA" },
    { value: "Eugene", label: "Eugene, OR" },
    { value: "Evansville", label: "Evansville, IN" },
    { value: "Everett", label: "Everett, WA" },
    { value: "Fargo", label: "Fargo, ND" },
    { value: "Fayetteville", label: "Fayetteville, NC" },
    { value: "Flint", label: "Flint, MI" },
    { value: "Fort Collins", label: "Fort Collins, CO" },
    { value: "Fort Lauderdale", label: "Fort Lauderdale, FL" },
    { value: "Fort Smith", label: "Fort Smith, AR" },
    { value: "Fort Wayne", label: "Fort Wayne, IN" },
    { value: "Fort Worth", label: "Fort Worth, TX" },
    { value: "Fremont", label: "Fremont, CA" },
    { value: "Fresno", label: "Fresno, CA" },
    { value: "Frisco", label: "Frisco, TX" },
    { value: "Fullerton", label: "Fullerton, CA" },
    { value: "Gainesville", label: "Gainesville, FL" },
    { value: "Garland", label: "Garland, TX" },
    { value: "Gilbert", label: "Gilbert, AZ" },
    { value: "Glendale", label: "Glendale, AZ" },
    { value: "Grand Prairie", label: "Grand Prairie, TX" },
    { value: "Grand Rapids", label: "Grand Rapids, MI" },
    { value: "Green Bay", label: "Green Bay, WI" },
    { value: "Greensboro", label: "Greensboro, NC" },
    { value: "Greenville", label: "Greenville, SC" },
    { value: "Gulfport", label: "Gulfport, MS" },
    { value: "Hartford", label: "Hartford, CT" },
    { value: "Hayward", label: "Hayward, CA" },
    { value: "Henderson", label: "Henderson, NV" },
    { value: "Hialeah", label: "Hialeah, FL" },
    { value: "Hillsboro", label: "Hillsboro, OR" },
    { value: "Hoboken", label: "Hoboken, NJ" },
    { value: "Hollywood", label: "Hollywood, FL" },
    { value: "Honolulu", label: "Honolulu, HI" },
    { value: "Houston", label: "Houston, TX" },
    { value: "Huntington Beach", label: "Huntington Beach, CA" },
    { value: "Huntsville", label: "Huntsville, AL" },
    { value: "Idaho Falls", label: "Idaho Falls, ID" },
    { value: "Indianapolis", label: "Indianapolis, IN" },
    { value: "Iowa City", label: "Iowa City, IA" },
    { value: "Irvine", label: "Irvine, CA" },
    { value: "Irving", label: "Irving, TX" },
    { value: "Jacksonville", label: "Jacksonville, FL" },
    { value: "Jersey City", label: "Jersey City, NJ" },
    { value: "Kansas City", label: "Kansas City, MO" },
    { value: "Kenosha", label: "Kenosha, WI" },
    { value: "Kent", label: "Kent, WA" },
    { value: "Killeen", label: "Killeen, TX" },
    { value: "Knoxville", label: "Knoxville, TN" },
    { value: "Lafayette", label: "Lafayette, LA" },
    { value: "Lakeland", label: "Lakeland, FL" },
    { value: "Lakewood", label: "Lakewood, CO" },
    { value: "Lancaster", label: "Lancaster, CA" },
    { value: "Lansing", label: "Lansing, MI" },
    { value: "Laredo", label: "Laredo, TX" },
    { value: "Las Cruces", label: "Las Cruces, NM" },
    { value: "Las Vegas", label: "Las Vegas, NV" },
    { value: "Lawrence", label: "Lawrence, KS" },
    { value: "Lehi", label: "Lehi, UT" },
    { value: "Lexington", label: "Lexington, KY" },
    { value: "Lincoln", label: "Lincoln, NE" },
    { value: "Little Rock", label: "Little Rock, AR" },
    { value: "Long Beach", label: "Long Beach, CA" },
    { value: "Los Angeles", label: "Los Angeles, CA" },
    { value: "Louisville", label: "Louisville, KY" },
    { value: "Lowell", label: "Lowell, MA" },
    { value: "Lubbock", label: "Lubbock, TX" },
    { value: "Macon", label: "Macon, GA" },
    { value: "Madison", label: "Madison, WI" },
    { value: "Manchester", label: "Manchester, NH" },
    { value: "McAllen", label: "McAllen, TX" },
    { value: "McKinney", label: "McKinney, TX" },
    { value: "Memphis", label: "Memphis, TN" },
    { value: "Meridian", label: "Meridian, ID" },
    { value: "Mesa", label: "Mesa, AZ" },
    { value: "Miami", label: "Miami, FL" },
    { value: "Milwaukee", label: "Milwaukee, WI" },
    { value: "Minneapolis", label: "Minneapolis, MN" },
    { value: "Missoula", label: "Missoula, MT" },
    { value: "Mobile", label: "Mobile, AL" },
    { value: "Modesto", label: "Modesto, CA" },
    { value: "Montgomery", label: "Montgomery, AL" },
    { value: "Mountain View", label: "Mountain View, CA" },
    { value: "Murfreesboro", label: "Murfreesboro, TN" },
    { value: "Naperville", label: "Naperville, IL" },
    { value: "Nashville", label: "Nashville, TN" },
    { value: "New Haven", label: "New Haven, CT" },
    { value: "New Orleans", label: "New Orleans, LA" },
    { value: "New York", label: "New York, NY" },
    { value: "Newark", label: "Newark, NJ" },
    { value: "Newport News", label: "Newport News, VA" },
    { value: "Norfolk", label: "Norfolk, VA" },
    { value: "Norman", label: "Norman, OK" },
    { value: "Oakland", label: "Oakland, CA" },
    { value: "Oceanside", label: "Oceanside, CA" },
    { value: "Odessa", label: "Odessa, TX" },
    { value: "Ogden", label: "Ogden, UT" },
    { value: "Oklahoma City", label: "Oklahoma City, OK" },
    { value: "Olathe", label: "Olathe, KS" },
    { value: "Omaha", label: "Omaha, NE" },
    { value: "Ontario", label: "Ontario, CA" },
    { value: "Orem", label: "Orem, UT" },
    { value: "Orlando", label: "Orlando, FL" },
    { value: "Overland Park", label: "Overland Park, KS" },
    { value: "Oxnard", label: "Oxnard, CA" },
    { value: "Palo Alto", label: "Palo Alto, CA" },
    { value: "Pasadena", label: "Pasadena, CA" },
    { value: "Paterson", label: "Paterson, NJ" },
    { value: "Pearland", label: "Pearland, TX" },
    { value: "Peoria", label: "Peoria, AZ" },
    { value: "Philadelphia", label: "Philadelphia, PA" },
    { value: "Phoenix", label: "Phoenix, AZ" },
    { value: "Pittsburgh", label: "Pittsburgh, PA" },
    { value: "Plano", label: "Plano, TX" },
    { value: "Pomona", label: "Pomona, CA" },
    { value: "Port St. Lucie", label: "Port St. Lucie, FL" },
    { value: "Portland", label: "Portland, OR" },
    { value: "Providence", label: "Providence, RI" },
    { value: "Provo", label: "Provo, UT" },
    { value: "Pueblo", label: "Pueblo, CO" },
    { value: "Queens", label: "Queens, NY" },
    { value: "Raleigh", label: "Raleigh, NC" },
    { value: "Rancho Cucamonga", label: "Rancho Cucamonga, CA" },
    { value: "Redmond", label: "Redmond, WA" },
    { value: "Redwood City", label: "Redwood City, CA" },
    { value: "Reno", label: "Reno, NV" },
    { value: "Renton", label: "Renton, WA" },
    { value: "Reston", label: "Reston, VA" },
    { value: "Richardson", label: "Richardson, TX" },
    { value: "Richmond", label: "Richmond, VA" },
    { value: "Riverside", label: "Riverside, CA" },
    { value: "Roanoke", label: "Roanoke, VA" },
    { value: "Rochester", label: "Rochester, NY" },
    { value: "Rockford", label: "Rockford, IL" },
    { value: "Rockville", label: "Rockville, MD" },
    { value: "Roseville", label: "Roseville, CA" },
    { value: "Round Rock", label: "Round Rock, TX" },
    { value: "Sacramento", label: "Sacramento, CA" },
    { value: "Salem", label: "Salem, OR" },
    { value: "Salinas", label: "Salinas, CA" },
    { value: "Salt Lake City", label: "Salt Lake City, UT" },
    { value: "San Antonio", label: "San Antonio, TX" },
    { value: "San Bernardino", label: "San Bernardino, CA" },
    { value: "San Diego", label: "San Diego, CA" },
    { value: "San Francisco", label: "San Francisco, CA" },
    { value: "San Jose", label: "San Jose, CA" },
    { value: "San Mateo", label: "San Mateo, CA" },
    { value: "Sandy Springs", label: "Sandy Springs, GA" },
    { value: "Santa Ana", label: "Santa Ana, CA" },
    { value: "Santa Barbara", label: "Santa Barbara, CA" },
    { value: "Santa Clara", label: "Santa Clara, CA" },
    { value: "Santa Fe", label: "Santa Fe, NM" },
    { value: "Santa Monica", label: "Santa Monica, CA" },
    { value: "Santa Rosa", label: "Santa Rosa, CA" },
    { value: "Sarasota", label: "Sarasota, FL" },
    { value: "Savannah", label: "Savannah, GA" },
    { value: "Scottsdale", label: "Scottsdale, AZ" },
    { value: "Seattle", label: "Seattle, WA" },
    { value: "Shreveport", label: "Shreveport, LA" },
    { value: "Silver Spring", label: "Silver Spring, MD" },
    { value: "Sioux Falls", label: "Sioux Falls, SD" },
    { value: "South Bend", label: "South Bend, IN" },
    { value: "Spokane", label: "Spokane, WA" },
    { value: "Springfield", label: "Springfield, MO" },
    { value: "St. Louis", label: "St. Louis, MO" },
    { value: "St. Paul", label: "St. Paul, MN" },
    { value: "St. Petersburg", label: "St. Petersburg, FL" },
    { value: "Stamford", label: "Stamford, CT" },
    { value: "Sterling Heights", label: "Sterling Heights, MI" },
    { value: "Stockton", label: "Stockton, CA" },
    { value: "Sugar Land", label: "Sugar Land, TX" },
    { value: "Sunnyvale", label: "Sunnyvale, CA" },
    { value: "Syracuse", label: "Syracuse, NY" },
    { value: "Tacoma", label: "Tacoma, WA" },
    { value: "Tallahassee", label: "Tallahassee, FL" },
    { value: "Tampa", label: "Tampa, FL" },
    { value: "Tempe", label: "Tempe, AZ" },
    { value: "Toledo", label: "Toledo, OH" },
    { value: "Topeka", label: "Topeka, KS" },
    { value: "Torrance", label: "Torrance, CA" },
    { value: "Trenton", label: "Trenton, NJ" },
    { value: "Tucson", label: "Tucson, AZ" },
    { value: "Tulsa", label: "Tulsa, OK" },
    { value: "Tuscaloosa", label: "Tuscaloosa, AL" },
    { value: "Tyler", label: "Tyler, TX" },
    { value: "Vallejo", label: "Vallejo, CA" },
    { value: "Vancouver", label: "Vancouver, WA" },
    { value: "Virginia Beach", label: "Virginia Beach, VA" },
    { value: "Visalia", label: "Visalia, CA" },
    { value: "Waco", label: "Waco, TX" },
    { value: "Washington", label: "Washington, DC" },
    { value: "Waterbury", label: "Waterbury, CT" },
    { value: "West Palm Beach", label: "West Palm Beach, FL" },
    { value: "West Valley City", label: "West Valley City, UT" },
    { value: "Westminster", label: "Westminster, CO" },
    { value: "Wichita", label: "Wichita, KS" },
    { value: "Wilmington", label: "Wilmington, NC" },
    { value: "Winston-Salem", label: "Winston-Salem, NC" },
    { value: "Worcester", label: "Worcester, MA" },
    { value: "Yonkers", label: "Yonkers, NY" },
];
